import DrKeywordCircleSvg from '@centria-ui/assets/images/dr-keyword/drkeyword-icon.svg'
import DrKeywordLogoSvg from '@centria-ui/assets/images/dr-keyword/logo.svg'

export const DrKeywordLogoIcon = () => <DrKeywordLogoSvg />
export const DrKeywordCircleIcon = () => <DrKeywordCircleSvg />
